/* eslint-disable no-case-declarations */

import { withStyles } from '@material-ui/core/styles'
import cn from 'classnames'

import Icon from '../Icon'

const styles = theme => ({
  content: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: theme.typography.fontSizeSmaller,
    padding: props => (props.tableGroupHeaderSize === 'large' ? '16px' : '8px 16px'),
    backgroundColor: `var(--gameday-table-tableHeaderRowBgColor, ${theme.table.tableHeaderRowBgColor})`,
    border: props => props.isMobile && theme.borders.default,
    marginBottom: '-1px',
    '&.isLocked': {
      backgroundColor: theme.table.tableHeaderLockedBgColor,
    },
  },
  tableHeader: {
    padding: props => (props.tableGroupHeaderSize === 'large' ? '16px 9px' : '8px 16px'),
    backgroundColor: `var(--gameday-table-tableHeaderRowBgColor, ${theme.table.tableHeaderRowBgColor})`,
    border: props => props.isMobile && theme.borders.default,
    marginBottom: '-1px',
    '&:last-child': {
      paddingRight: 9,
    },
    '&.isLocked': {
      backgroundColor: theme.table.tableHeaderLockedBgColor,
    },
  },
  danger: {
    backgroundColor: theme.status.errorBG,
    '&:first-child::before': {
      backgroundColor: theme.status.errorColor,
    },
  },
  heading: {
    textAlign: 'left',
    fontWeight: theme.typography.fontWeightBolder,
    '&.large': {
      fontSize: theme.typography.fontSizeSm,
    },
    '&:not(.large)': {
      textTransform: 'uppercase',
      fontWeight: theme.typography.fontWeightNormal,
    },
  },
  description: {
    textAlign: 'left',
    marginTop: '5px',
    fontWeight: theme.typography.fontWeightNormal,
  },
  dragging: {
    backgroundColor: 'transparent',
  },
  headingText: {
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  ruleCol: {
    textAlign: 'left',
    paddingLeft: '6px !important',
  },
  rules: {
    fontWeight: 400,
  },
  ruleIcon: {
    marginLeft: 12,
    color: `${`var(--gameday-table-tableHeaderTextColor, ${theme.table.tableHeaderTextColor})`} !important`,
  },
})

const TableRowHeaderContent = ({
  classes,
  row,
  count,
  heading,
  isDragging,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  isMobile,
  tableGroupActions,
  tableGroupCount,
  tableGroupDescription,
  tableGroupHeaderSize,
  tableGroupRules,
  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  className,
  cols,
}) => {
  const CheckRule = rule => {
    switch (rule.type) {
      case 'purchaseRule':
        return (
          <>
            {rule.value ? (
              <>
                {rule.show ? 'Select at least: ' : null}
                {rule.value ? rule.value : null}
                {rule.icon ? <Icon iconSize={20} iconName="hand-point" className={classes.ruleIcon} /> : null}
              </>
            ) : (
              // biome-ignore lint/complexity/noUselessFragments: TODO
              <>
                {rule.emptyLabel ? (
                  <>
                    {rule.emptyLabel}
                    {rule.icon ? <Icon iconSize={20} iconName="hand-point" className={classes.ruleIcon} /> : null}
                  </>
                ) : null}
              </>
            )}
          </>
        )
      case 'purchaseRuleMinMax': {
        const { min, max } = rule.value
        let message = ''

        if (min && max) {
          message = `Select between ${max} and ${min}`
        } else if (min && !max) {
          message = `Select at least: ${min}`
        } else if (!min && max) {
          message = `Select at most: ${max}`
        } else {
          message = 'No Limit'
        }

        return (
          <>
            {rule.value ? (
              <>
                {rule.show ? `${message}` : ''}
                {rule.icon ? <Icon iconSize={20} iconName="hand-point" className={classes.ruleIcon} /> : null}
              </>
            ) : (
              // biome-ignore lint/complexity/noUselessFragments: TODO
              <>
                {rule.emptyLabel ? (
                  <>
                    {rule.emptyLabel}
                    {rule.icon ? <Icon iconSize={20} iconName="hand-point" className={classes.ruleIcon} /> : null}
                  </>
                ) : null}
              </>
            )}
          </>
        )
      }
      default:
        return (
          <>
            {rule.value ? (
              <>
                {rule.label ? `${rule.label} ` : null}
                {rule.value ? rule.value : null}
                {rule.icon ? <Icon iconSize={20} iconName="hand-point" className={classes.ruleIcon} /> : null}
              </>
            ) : (
              // biome-ignore lint/complexity/noUselessFragments: TODO
              <>
                {rule.emptyLabel ? (
                  <>
                    {rule.emptyLabel}
                    {rule.icon ? <Icon iconSize={20} iconName="hand-point" className={classes.ruleIcon} /> : null}
                  </>
                ) : null}
              </>
            )}
          </>
        )
    }
  }

  const colSpan = cols - 3

  return (
    // <div className={cn(className, classes.content, row.action === 'delete' && classes.danger, isDragging && classes.dragging)}>
    <>
      <th
        colSpan="2"
        className={cn(classes.tableHeader, row.action === 'delete' && classes.danger, isDragging && classes.dragging)}
      >
        <div className={cn(classes.heading, tableGroupHeaderSize)}>
          {heading} {tableGroupCount && <>({count === undefined ? 0 : count})</>}
        </div>
        {(row.description || tableGroupDescription) && (
          <div className={classes.description}>{row.description || tableGroupDescription}</div>
        )}
      </th>
      <th
        colSpan={colSpan}
        className={cn(
          classes.tableHeader,
          classes.ruleCol,
          row.action === 'delete' && classes.danger,
          isDragging && classes.dragging
        )}
      >
        {row.rules || tableGroupRules ? (
          <span className={classes.rules}>{CheckRule(row.rules || tableGroupRules)}</span>
        ) : null}
      </th>
      <th
        className={cn(classes.tableHeader, row.action === 'delete' && classes.danger, isDragging && classes.dragging)}
      >
        {tableGroupActions && !row.isLocked ? (
          <span className={classes.actions}>{tableGroupActions({ ...row })}</span>
        ) : (
          <Icon iconSize={25} iconName="lock" color="gray" />
        )}
      </th>
      {/* </div> */}
    </>
  )
}

TableRowHeaderContent.defaultProps = {
  tableGroupHeaderSize: 'small',
}

const TableRowHeaderContentComponent = withStyles(styles)(TableRowHeaderContent)
TableRowHeaderContentComponent.displayName = 'TableRowHeaderContent'
export default TableRowHeaderContentComponent
